import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, ErrorMessage/*Field, useFormikContext */} from 'formik'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import 'react-datepicker/dist/react-datepicker.css'
import './customDatePickerWidth.css'
//import {format} from 'date-fns'

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
  paddingBottom: '20px',
}

const aStyle = {
  display: 'none',
}

const vacationTypeOptions = [
  { value: 'medical', label: 'Medical' },
  { value: 'rest', label: 'Rest' },
  { value: 'unpaid', label: 'Unpaid' },
]

const processUserList = (users) => {
  return users.map(user => ({ 'value': user.id, 'label': user.name }))
}

const TimeOffForm = props => <Formik initialValues={{ user_id: props.vacation.vacation.user_id, start_date: Date.parse(props.vacation.vacation.start_date), end_date: Date.parse(props.vacation.vacation.end_date), vacation_type: props.vacation.vacation.vacation_type, vacation_user_id: props.vacation.vacation.user_admin ? null : props.vacation.vacation.user_id }} enableReinitialize={true} validate={values => {
      const errors = {}
      if (!values.vacation_user_id) {
        errors.vacation_user_id = 'Required'
      } else if (!values.start_date) {
        errors.start_date = 'Required'
      } else if (!values.end_date) {
        errors.end_date = 'Required'
      } else if (!values.vacation_type) {
        errors.vacation_type = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      let body = ''
      const startv = new Date(values.start_date)
      const startdatev = new Date(startv.getTime() - (startv.getTimezoneOffset() * 60000)).toISOString()
      .replace(/T/, ' ')
      .replace(/\..+/, '')
      const endv = new Date(values.end_date)
      const enddatev = new Date(endv.getTime() - (endv.getTimezoneOffset() * 60000)).toISOString()
      .replace(/T/, ' ')
      .replace(/\..+/, '')
      body = JSON.stringify({
        id: props.vacation.vacation.user_id,
        start_date: startdatev,
        end_date: enddatev,
        vacation_type: values.vacation_type,
        vacation_user_id: values.vacation_user_id,
      })
      const urlf = '/api/v1/vacations'
      let meth = ''
      meth = 'POST'
      fetch(urlf, {
        method: meth,
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
      .then(response => response.json())
      .then(() => {
        document.getElementById('mylink').click()
      })
      .catch((err) => {
        document.getElementById('mylink').click()
        console.error('Error while adding time off! ' + err)
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)
    }}>{({ isSubmitting, errors, values, setFieldValue}) => <Fragment><a href={'/accounting/' + props.vacation.vacation.user_id} id="mylink" style={aStyle}></a><div className="row col-sm-12 justify-content-top"><h3>Add time off</h3></div><br /><Form>{props.vacation.vacation.user_admin ? <div className="row"><div className="col-xs-12 col-sm-6"><label htmlFor="vacation_user">Employee</label><br /><div><Select id="vacation_user" name="vacation_user_id" options={processUserList(props.vacation.vacation.users)} defaultValue={props.vacation.vacation.user_id} onChange={ ({value}) => { setFieldValue('vacation_user_id', value, false) }}></Select></div><ErrorMessage name="vacation_user_id" component="div"></ErrorMessage><br /></div></div> : <input type="hidden" value={props.vacation.vacation.user_id} />}<div className="row col-sm-12"><div className="col-sm-6" style={divStyle}><div><label htmlFor="start_date">Start date</label><br /><div className="customDatePickerWidth"><DatePicker name="start_date" dateFormat="dd/MM/yyyy" placeholderText="dd/mm/yyyy" utcOffset={0} selected={values.start_date} className={'form-control' + (errors.start_date ? ' is-invalid' : '')} onChange={ (val) => { setFieldValue('start_date', val, false), setFieldValue('end_date', val, false) }} onSelect={ (val) => setFieldValue('start_date', val, false) }></DatePicker></div></div><ErrorMessage name="start_date" component="div"></ErrorMessage><br /><label htmlFor="vacation_type">Type</label><br /><Select name="vacation_type" options={vacationTypeOptions} onChange={e => setFieldValue('vacation_type', e.value, false)}></Select><ErrorMessage name="vacation_type" component="div"></ErrorMessage><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="end_date">End date</label><br /><div className="customDatePickerWidth"><DatePicker name="end_date" dateFormat="dd/MM/yyyy" placeholderText="dd/mm/yyyy" utcOffset={0} selected={values.end_date} className={'form-control' + (errors.end_date ? ' is-invalid' : '')} onChange={ (val) => { setFieldValue('end_date', val, false) }} onSelect={ (val) => setFieldValue('end_date', val, false) } style={{width: '100%'}}></DatePicker></div></div><ErrorMessage name="end_date" component="div"></ErrorMessage><br /></div><br /><br /><button type="submit" disabled={isSubmitting} className="btn btn-outline-secondary">Add time off</button><br /><br /></div></Form></Fragment>}</Formik>

TimeOffForm.propTypes = {
  vacation: PropTypes.object,
}

export default TimeOffForm
